var _path, _path2, _ellipse, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44409 1.40039V7.00039H15.4765",
    stroke: "#152D5D",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4757 11.6004L15.4757 6.50321C15.4757 6.22509 15.3599 5.95954 15.1561 5.77032L10.7364 1.6675C10.5515 1.49581 10.3084 1.40039 10.0561 1.40039L2.40003 1.40041C1.84774 1.40041 1.40003 1.84813 1.40003 2.40041L1.40003 17.2004C1.40003 17.7527 1.84775 18.2004 2.40003 18.2004L11.3 18.2004",
    stroke: "#152D5D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8,
    cy: 16.4006,
    rx: 4.8,
    ry: 4.8,
    stroke: "#152D5D",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 16.4004H14",
    stroke: "#152D5D",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7999 18.2006V14.6006",
    stroke: "#152D5D",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNDQ0MDkgMS40MDAzOVY3LjAwMDM5SDE1LjQ3NjUiIHN0cm9rZT0iIzE1MkQ1RCIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS40NzU3IDExLjYwMDRMMTUuNDc1NyA2LjUwMzIxQzE1LjQ3NTcgNi4yMjUwOSAxNS4zNTk5IDUuOTU5NTQgMTUuMTU2MSA1Ljc3MDMyTDEwLjczNjQgMS42Njc1QzEwLjU1MTUgMS40OTU4MSAxMC4zMDg0IDEuNDAwMzkgMTAuMDU2MSAxLjQwMDM5TDIuNDAwMDMgMS40MDA0MUMxLjg0Nzc0IDEuNDAwNDEgMS40MDAwMyAxLjg0ODEzIDEuNDAwMDMgMi40MDA0MUwxLjQwMDAzIDE3LjIwMDRDMS40MDAwMyAxNy43NTI3IDEuODQ3NzUgMTguMjAwNCAyLjQwMDAzIDE4LjIwMDRMMTEuMyAxOC4yMDA0IiBzdHJva2U9IiMxNTJENUQiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxlbGxpcHNlIGN4PSIxNS44IiBjeT0iMTYuNDAwNiIgcng9IjQuOCIgcnk9IjQuOCIgc3Ryb2tlPSIjMTUyRDVEIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTE3LjYgMTYuNDAwNEgxNCIgc3Ryb2tlPSIjMTUyRDVEIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE1Ljc5OTkgMTguMjAwNlYxNC42MDA2IiBzdHJva2U9IiMxNTJENUQiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K";